<template>
  <div class="footer-main">
    <div class="year-css">2022 © rakurakucarrer</div>
    <span>Puchase</span>
    <span>Support</span>
    <span>About</span>
  </div>
</template>
<script>
export default {
  name: "footer-box",
  components: {},
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {}
};
</script>
<style scoped>
/* @media (min-width: 1349px) { */
  .footer-main {
    width: calc(100% - 266px);
    /* width: 100%; */
    /* margin-left: 2.5%; */
    position: absolute;
    bottom: 0;
    left: 266px;
    background: #fff;
    height: 60px;
    line-height: 60px;
    border-top: 1px solid #e0e1ea;
    font-family: "Work Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    align-items: center;
    letter-spacing: -0.02em;
    color: #c9cfda;
  }
/* } */
/* @media (max-width: 1349px) {
  .footer-main {
    
    width: 100%;
   

    position: absolute;
    bottom: 0;
   
    background: #fff;
    height: 60px;
    line-height: 60px;
    border-top: 1px solid #e0e1ea;
    font-family: "Work Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    align-items: center;
    letter-spacing: -0.02em;
    color: #c9cfda;
  }
} */

.footer-main span {
  float: right;
  margin-right: 20px;
  cursor: pointer;
}
.year-css {
  float: left;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue